/**
 * 示例菜谱：price/cost 均为单人份。
 * 配菜时再 × 人数得到每道菜售价与成本（约 6 人、人均 500、利润率 30% 可配出菜单）。
 */
export const SEED_DISHES = [
  { id: 'seed_h1', name: '清蒸鲈鱼', category: 'hard', price: 48, cost: 18 },
  { id: 'seed_h2', name: '红烧狮子头', category: 'hard', price: 42, cost: 16 },
  { id: 'seed_h3', name: '香辣蟹', category: 'hard', price: 58, cost: 24 },
  { id: 'seed_h4', name: '东坡肉', category: 'hard', price: 38, cost: 15 },
  { id: 'seed_h5', name: '清炖鸡', category: 'hard', price: 45, cost: 18 },

  { id: 'seed_n1', name: '宫保鸡丁', category: 'normal', price: 18, cost: 7 },
  { id: 'seed_n2', name: '鱼香肉丝', category: 'normal', price: 16, cost: 6 },
  { id: 'seed_n3', name: '干煸四季豆', category: 'normal', price: 12, cost: 4 },
  { id: 'seed_n4', name: '糖醋排骨', category: 'normal', price: 22, cost: 9 },
  { id: 'seed_n5', name: '蒜蓉粉丝蒸扇贝', category: 'normal', price: 25, cost: 10 },
  { id: 'seed_n6', name: '酸辣土豆丝', category: 'normal', price: 10, cost: 3 },
  { id: 'seed_n7', name: '椒盐虾', category: 'normal', price: 28, cost: 12 },
  { id: 'seed_n8', name: '麻婆豆腐', category: 'normal', price: 12, cost: 4 },
  { id: 'seed_n9', name: '香菇青菜', category: 'normal', price: 14, cost: 5 },
  { id: 'seed_n10', name: '京酱肉丝', category: 'normal', price: 18, cost: 7 },

  { id: 'seed_d1', name: '蟹黄灌汤包', category: 'dessert', price: 16, cost: 6 },
  { id: 'seed_d2', name: '榴莲酥', category: 'dessert', price: 12, cost: 4 },
  { id: 'seed_d3', name: '红糖发糕', category: 'dessert', price: 10, cost: 3 },
  { id: 'seed_d4', name: '双皮奶', category: 'dessert', price: 8, cost: 3 },

  { id: 'seed_f1', name: '时令鲜果拼盘', category: 'fruit', price: 18, cost: 7 },
  { id: 'seed_f2', name: '杨枝甘露', category: 'fruit', price: 14, cost: 5 },
  { id: 'seed_f3', name: '西瓜拼盘', category: 'fruit', price: 12, cost: 4 },

  { id: 'seed_s1', name: '扬州炒饭', category: 'staple', price: 12, cost: 4 },
  { id: 'seed_s2', name: '小笼包', category: 'staple', price: 14, cost: 5 },
  { id: 'seed_s3', name: '阳春面', category: 'staple', price: 10, cost: 3 },
  { id: 'seed_s4', name: '蛋炒饭', category: 'staple', price: 12, cost: 4 },

  { id: 'seed_v1', name: '手撕包菜', category: 'seasonal', price: 10, cost: 3 },
  { id: 'seed_v2', name: '清炒时蔬', category: 'seasonal', price: 12, cost: 4 },
  { id: 'seed_v3', name: '蒜蓉西兰花', category: 'seasonal', price: 12, cost: 4 },
  { id: 'seed_v4', name: '干锅花菜', category: 'seasonal', price: 14, cost: 5 },

  { id: 'seed_w1', name: '西湖牛肉羹', category: 'wei', price: 12, cost: 4 },
  { id: 'seed_w2', name: '玉米排骨汤', category: 'wei', price: 14, cost: 5 },
  { id: 'seed_w3', name: '银耳莲子羹', category: 'wei', price: 10, cost: 3 }
]
